<template>
  <caption class="confetti-table-heading">
    <h5>{{ headingText }}</h5>
    <slot />
  </caption>
</template>

<script>
export default {
  name: "ConfettiTableHeading",
  props: {
    headingText: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/tables/confetti-table-heading";
</style>
